<script lang="ts" setup>
defineProps<{ dateStart?: string, dateEnd?: string }>()
</script>

<template>
  <div
    v-if="dateStart || dateEnd"
    class="flex flex-wrap gap-2 mt-6"
  >
    <Icon
      name="heroicons:calendar"
      class="w-6 h-6 inline-block"
    />
    <div class="flex gap-4 flex-wrap">
      <p v-if="dateStart">
        <span class="inline-block mr-2 font-normal">From:</span>  {{ useDateFormat(dateStart, 'hh:mma D/MM/YY') }}
      </p>
      <p v-if="dateEnd">
        <span class="inline-block mr-2 font-normal">To:</span>{{ useDateFormat(dateEnd, 'hh:mma D/MM/YY') }}
      </p>
    </div>
  </div>
</template>
